<template>
  <container>
    <!-- Filters -->
    <div style="padding-bottom:25px;padding-top:25px" class="flex">
      <select v-model="selectedYear"  name="type" @change="yearChangeHandle"  class="yearSelect">
                                <option>2018</option>
                                <option>2019</option>  
                                <option>AllTime</option>                                    
      </select>

      <select  v-model="selectedMonth" name="type" @change="monthChangeHandle"  class="yearSelect">
                                <option v-for= "month in filteredmonths" :value="month" :disabled="isAllTime">{{month}}</option>                                  
      </select>



      <select v-model="selectedMedal"  name="type" @change="medalChangeHandle"  class="yearSelect">
                                <option  style="display:none"># of Medals</option>
                                <option value="gold"># of Gold Medals</option>
                                <option value="silver"># of Silver Medals</option>  
                                <option value="bronze"># of Bronze Medals</option> 
                                <option value="live"># of Live Medals</option>                                    
      </select>

      <div></div>
    
    </div>
    <!-- Table -->
    <v-table
      is-horizontal-resize
      style="width:100%;"
      :columns="columns"
      :table-data="tableData"
      :show-vertical-border="true"
      :title-bg-color = "'#7ef8fc'"
      :title-row-height ="30"
      :border="1"
      :paging-index="(pageIndex-1)*pageSize"
    ></v-table>
    <!-- Pagination -->
    <div class="mt20 mb20 bold" style="padding-top:25px">
                       <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
    </div>
  </container>
</template>
<script>
import Container from '@/components/Container'
import 'vue-easytable/libs/themes-base/index.css'
import {VTable,VPagination} from 'vue-easytable'
import Vue from "vue"
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
import {prop, sortWith, descend, ascend, sortBy, sort} from 'ramda'
import MedalService from '@/services/medals'
export default {
  name: 'medal',
  data () {
    return {
      tableData: [],
      columns: [
                {field: "name", title:'Name', width: 300, titleAlign: 'center',columnAlign:'center',isResize:true},
                {field: "id", title:'ID', width: 130, titleAlign: 'center',columnAlign:'center',componentName:'runner-id'},
                {field: "totalcount", title:'#', width: 130, titleAlign: 'center',columnAlign:'center'},
                {field: "goldcount", title:'Gold', width: 130, titleAlign: 'center',columnAlign:'center'},
                {field: "silvercount", title:'Silver', width:130, titleAlign: 'center',columnAlign:'center'},
                {field: "bronzecount", title:'Bronze', width: 130, titleAlign: 'center',columnAlign:'center'},
                {field: "livecount", title:'Live', width: 130, titleAlign: 'center',columnAlign:'center'}
               
              ],
      runner:[],
      pageIndex:0,
      pageTotal:null,
      pageSize:10,
      totalElement:null,
      selectedYear:2019,
      selectedMonth:'Jan',
      selectedMedal:'# of Medals',
      isAllTime:false,
      months:[
        {name:'Jan',number:1},
        {name:'Feb',number:2},
        {name:'Mar',number:3},
        {name:'Apr',number:4},
        {name:'May',number:5},
        {name:'Jun',number:6},
        {name:'Jul',number:7},
        {name:'Aug',number:8},
        {name:'Sept',number:9},
        {name:'Oct',number:10},
        {name:'Nov',number:11},
        {name:'Dec',number:12}],
      filteredmonths:[
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec']    
    }
    
   
  },
  computed: {
  
  },
 
  methods: {
    async getAllMedals(year,month,index, size, selectedMedal){
      this.runner = []
           let Gold =  await MedalService.getMedals(1,year,month,index, size)
           let Silver =  await MedalService.getMedals(2,year,month,index, size)
           let Bronze =  await MedalService.getMedals(3,year,month,index, size)
           let Live =  await MedalService.getMedals(60,year,month,index, size)
           this.pageTotal = Gold.data.totalElements
           let RunnerGoldmedals =  Gold.data.content
           let RunnerSilvermedals =  Silver.data.content
           let RunnerBronzemedals =  Bronze.data.content
           let RunnerLivemedals =  Live.data.content

           RunnerGoldmedals.forEach(gold => {
              let runner = {}
              let silverObj = RunnerSilvermedals.filter(silver => silver.runner.id === gold.runner.id)
              let bronzeObj = RunnerBronzemedals.filter(bronze => bronze.runner.id === gold.runner.id)
              let liveObj = RunnerLivemedals.filter(live => live.runner.id === gold.runner.id)

              if(silverObj.length>0)
                    runner['silvercount'] = silverObj[0].count
              else
                runner['silvercount'] = 0
              
              if(bronzeObj.length>0)
                    runner['bronzecount'] = bronzeObj[0].count
              else
                runner['bronzecount'] = 0

              if(liveObj.length>0)
                    runner['livecount'] = liveObj[0].count
              else
                runner['livecount'] = 0

                runner['goldcount'] = gold.count
                runner['id'] = gold.runner.id
                runner['name'] = gold.runner.firstName
              
                runner['totalcount'] = runner.goldcount+runner.silvercount+runner.bronzecount+runner.livecount
              
              this.runner.push(runner)
           })

          this.tableData = this.runner
    },

    insertData(medal1,medal2, medal3, medal4){
      this.runner = []
      medal1.forEach(defaultMedal => {
        let runner = {}
        let secondMedal = medal2.filter(second => second.runner.id === defaultMedal.runner.id)
        let thirdMedal = medal3.filter(third => third.runner.id === defaultMedal.runner.id)
        let fourthMedal = medal4.filter(fourth => fourth.runner.id === defaultMedal.runner.id)
        if(defaultMedal.medal.id == 1){
          runner['goldcount'] = defaultMedal.count
        }else if(defaultMedal.medal.id == 2){
          runner['silvercount'] = defaultMedal.count
        }else if(defaultMedal.medal.id == 3){
          runner['bronzecount'] = defaultMedal.count
        }else{
          runner['livecount'] = defaultMedal.count
        }


        if(secondMedal.length>0){
          if(secondMedal[0].medal.id == 1){
            runner['goldcount'] = secondMedal[0].count
          }else if(secondMedal[0].medal.id == 2){
            runner['silvercount'] = secondMedal[0].count
          }else if(secondMedal[0].medal.id == 3){
            runner['bronzecount'] = secondMedal[0].count
          }else{
            runner['livecount'] = secondMedal[0].count
          }
        }

        if(thirdMedal.length>0){
          if(thirdMedal[0].medal.id == 1){
            runner['goldcount'] = thirdMedal[0].count
          }else if(thirdMedal[0].medal.id == 2){
            runner['silvercount'] = thirdMedal[0].count
          }else if(thirdMedal[0].medal.id == 3){
            runner['bronzecount'] = thirdMedal[0].count
          }else{
            runner['livecount'] = thirdMedal[0].count
          }
        }

        if(fourthMedal.length>0){
          if(fourthMedal[0].medal.id == 1){
            runner['goldcount'] = fourthMedal[0].count
          }else if(fourthMedal[0].medal.id == 2){
            runner['silvercount'] = fourthMedal[0].count
          }else if(fourthMedal[0].medal.id == 3){
            runner['bronzecount'] = fourthMedal[0].count
          }else{
            runner['livecount'] = fourthMedal[0].count
          }
        }

        runner.goldcount = runner.goldcount?runner.goldcount:0
        runner.silvercount = runner.silvercount?runner.silvercount:0
        runner.bronzecount = runner.bronzecount?runner.bronzecount:0
        runner.livecount = runner.livecount?runner.livecount:0
        runner['id'] = defaultMedal.runner.id
        runner['name'] = defaultMedal.runner.firstName
        
        runner['totalcount'] = runner.goldcount+runner.silvercount+runner.bronzecount+runner.livecount
          
        this.runner.push(runner)
      })
      this.tableData = this.runner
    },
    getTableData(){
        this.tableData = this.runner
        this.pageTotal = this.pageTotal
    },
    pageChange(pageIndex){
          this.pageIndex = pageIndex-1
          this.pastRaces = []
          this.getTableData()
          let filteredMonth = this.getSelectedMonth()
         
          if(this.selectedMedal === 'gold' || this.selectedMedal === 'silver' || this.selectedMedal === 'bronze' || this.selectedMedal === 'live'){
                return this.medalChangeHandle()
          }
          if(this.selectedYear === 'AllTime'){  
            return this.getAllMedals(null,null, this.pageIndex,this.pageSize) 
          }
          this.getAllMedals(this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        
    },
    pageSizeChange(pageSize){

        this.pageIndex = 0
        this.pageSize = pageSize
        this.pastRaces = []
        this.getTableData()
        this.getAllMedals(this.pageIndex, this.pageSize)
        
    },
    
    yearChangeHandle(){
      this.isAllTime = false
      this.selectedMedal = '# of Medals'
      if(this.selectedYear === 'AllTime' & this.selectedMedal == '# of Medals')  {
          this.isAllTime = true
          return this.getAllMedals(null,null,0,10)
      }
      let filteredMonth = this.getSelectedMonth()
      this.getAllMedals(this.selectedYear,filteredMonth.number,0,10)
    },
    monthChangeHandle(){
      this.selectedMedal = '# of Medals'
        let filteredMonth = this.getSelectedMonth() 

        this.getAllMedals(this.selectedYear,filteredMonth.number,0,10)
    },
    async medalChangeHandle(){
      if(this.selectedYear == 'AllTime'){
        this.isAllTime = true
      }
      // this.selectedYear = 'AllTime'
      // this.isAllTime = true
      let filteredMonth = this.getSelectedMonth()
      if(this.selectedMedal === 'gold'){
        let Gold =  await MedalService.getMedals(1,null,null,this.pageIndex,this.pageSize)
        this.pageTotal = Gold.data.totalElements
        let Silver =  await MedalService.getMedals(2,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Bronze =  await MedalService.getMedals(3,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Live =  await MedalService.getMedals(60,this.selectedYear,filteredMonth.number,this.pageIndex,this.pageSize)
        this.insertData(Gold.data.content,Silver.data.content, Bronze.data.content,Live.data.content)
      }

      if(this.selectedMedal === 'silver'){
        let Gold =  await MedalService.getMedals(1,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Silver =  await MedalService.getMedals(2,null,null,this.pageIndex,this.pageSize)
        this.pageTotal = Silver.data.totalElements
        let Bronze =  await MedalService.getMedals(3,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Live =  await MedalService.getMedals(60,this.selectedYear,filteredMonth.number,this.pageIndex,this.pageSize)
        this.insertData(Silver.data.content,Gold.data.content, Bronze.data.content,Live.data.content)
      }

      if(this.selectedMedal === 'bronze'){
        let Gold =  await MedalService.getMedals(1,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Silver =  await MedalService.getMedals(2,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Bronze =  await MedalService.getMedals(3,null,null,this.pageIndex,this.pageSize)
        this.pageTotal = Bronze.data.totalElements
        let Live =  await MedalService.getMedals(60,this.selectedYear,filteredMonth.number,this.pageIndex,this.pageSize)
        this.insertData(Bronze.data.content, Gold.data.content,Silver.data.content,Live.data.content)
      }

      if(this.selectedMedal === 'live'){
        let Gold =  await MedalService.getMedals(1,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Silver =  await MedalService.getMedals(2,this.selectedYear,filteredMonth.number, this.pageIndex,this.pageSize)
        let Bronze =  await MedalService.getMedals(3,this.selectedYear,filteredMonth.number,this.pageIndex,this.pageSize)
        let Live =  await MedalService.getMedals(60,null,null,this.pageIndex,this.pageSize)
        this.pageTotal = Live.data.totalElements
       this.insertData(Live.data.content, Bronze.data.content, Gold.data.content,Silver.data.content)
      }
    },
    
    getSelectedMonth(){
      return this.months.find((m)=>m.name === this.selectedMonth)
    }
  },
  created () {
          this.getAllMedals(this.selectedYear,this.selectedMonth.number, 0,10)
  },
  watch: {

  },
  components: {
    Container
  }
}

Vue.component('runner-id',{
        template:`<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.id}}</a>&nbsp
        </span>`,
        data: () => ({
        //   id:null 
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          runnerData(){

              let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: this.rowData.id
                        }
                    })
              window.open(route.href, '_blank')
          }
        },
        created() { 
        }
})
</script>
<style>
.yearSelect{
      padding: 10px 30px 10px 25px;
    font-size: 15px;
    background-color: white;
}
</style>



// WEBPACK FOOTER //
// Medal.vue?220a1572